/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDiscountFromJSON, ApiDiscountToJSON, } from './ApiDiscount';
import { ApiProductFromJSON, ApiProductToJSON, } from './ApiProduct';
import { ApiProfitMarginFromJSON, ApiProfitMarginToJSON, } from './ApiProfitMargin';
import { ApiSaleFromJSON, ApiSaleToJSON, } from './ApiSale';
export function ApiSaleItemFromJSON(json) {
    return ApiSaleItemFromJSONTyped(json, false);
}
export function ApiSaleItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'discounts': !exists(json, 'discounts') ? undefined : (json['discounts'].map(ApiDiscountFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'product': !exists(json, 'product') ? undefined : ApiProductFromJSON(json['product']),
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
        'profitMargin': !exists(json, 'profitMargin') ? undefined : json['profitMargin'],
        'profitMargins': !exists(json, 'profitMargins') ? undefined : (json['profitMargins'].map(ApiProfitMarginFromJSON)),
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'sale': !exists(json, 'sale') ? undefined : ApiSaleFromJSON(json['sale']),
        'saleId': !exists(json, 'saleId') ? undefined : json['saleId'],
        'subscriptionId': !exists(json, 'subscriptionId') ? undefined : json['subscriptionId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiSaleItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'discounts': value.discounts === undefined ? undefined : (value.discounts.map(ApiDiscountToJSON)),
        'id': value.id,
        'price': value.price,
        'product': ApiProductToJSON(value.product),
        'productId': value.productId,
        'profitMargin': value.profitMargin,
        'profitMargins': value.profitMargins === undefined ? undefined : (value.profitMargins.map(ApiProfitMarginToJSON)),
        'quantity': value.quantity,
        'sale': ApiSaleToJSON(value.sale),
        'saleId': value.saleId,
        'subscriptionId': value.subscriptionId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
